import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { IPropertyList, IPropertyDetails, ISaveDeleteResponse, IisExist } from '../Shared/interface';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import { IPaymentGatewayModel, IcreditCardTransactionInput } from '../Shared/interface2';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root',
})

export class PropProtecService {
    private baseURL = this.appService.config.apiBaseUrl;

  constructor(private http: HttpClient,
              private appinsights: AppInsightsService,
              private appService: AppService) { }

  getPropertyPage(): Observable<IPropertyList[]> {
    return this.http.get<IPropertyList[]>(
        `${this.baseURL}/PropertyProtection/GetPropertyProtections`,
        { observe: 'response' })
        .pipe(
            map(res => {
                const pagedResult = res.body as IPropertyList[];
                return pagedResult;
            }),
            catchError(this.handleError)
        );
  }

  GetPropertyDetails(id: number): Observable<IPropertyDetails> {
    return this.http.get<IPropertyDetails>(
        `${this.baseURL}/PropertyProtection/GetPropertyProtectionDetails?propertyProtectionId=${id}`,
        {observe : 'response'})
        .pipe(
            map(res => {
                const ppDetail = res.body as IPropertyDetails;
                return ppDetail;
            }),
            catchError(this.handleError)
        );
  }

  GetPropertyDetailsForOp(id: number): Observable<IPropertyDetails> {
    return this.http.get<IPropertyDetails>(
        `${this.baseURL}/PropertyProtection/GetPropertyProtectionDetailsForOp?propertyProtectionId=${id}`,
        {observe : 'response'})
        .pipe(
            map(res => {
                const ppDetail = res.body as IPropertyDetails;
                return ppDetail;
            }),
            catchError(this.handleError)
        );
  }

  SavePPDetails(ppdetails: IPropertyDetails): Observable<ISaveDeleteResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    let url = '';
    if (ppdetails.Id === 0) {
      url = `${this.baseURL}/PropertyProtection/CreatePropertyProtection`;
    } else {
      url = `${this.baseURL}/PropertyProtection/UpdatePropertyProtectionDetail`;
    }
    return this.http.post<ISaveDeleteResponse>(url, ppdetails, options)
        .pipe(
            map(res => {
                return res;
            }),
            catchError(this.handleError)
        );
}

deletePPDetails(ppId: number) {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/PropertyProtection/DeletePropertyProtection?propertyProtectionId=${ppId}`,
     options);
}

getIsCompNameExists(Name: string): Observable<IisExist> {
    return this.http.get<IisExist>(
        `${this.baseURL}/PropertyProtection/IsPropertyProtectionExist?propertyProtectionName=${Name}`,
        { observe: 'response' })
        .pipe(
            map(result => {
                const isExist = result.body as IisExist;
                    return isExist;
            }
            ),
            catchError(this.handleError)
        );
}

IsCoverageNameExists(coverageName: string, companyId: number): Observable<any> {
  return this.http.get<any>(
    `${this.baseURL}/PropertyProtection/IsCoverageNameExists?coverageName=${coverageName}&companyId=${companyId}`,
      { observe: 'response' })
      .pipe(
          map(result => {
              const isExist = result.body as any;
                  return isExist;
          }
          ),
          catchError(this.handleError)
      );
}

getLettersByTransactionType(facId, transTypeId):Observable<any> {
  return this.http.get<any>(
      `${this.baseURL}/DocumentMerger/GetLettersByTransactionType?facilityId=${facId}&transactionTypeId=${transTypeId}`,
      { observe: 'response' })
      .pipe(
          map(res => {
              const lettersList = res.body as any;
              return lettersList;
          }),
          catchError(this.handleError)
      );
}

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
        const errMessage = error.error.message;
        this.appinsights.logEvent(errMessage);
        return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }

  private handleHttpPostError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
        console.error(error);
        return of(result as T);
    };
  }
}
